import { useAuthContext } from "providers/authContext";
import LoadingScreen from "app/LoadingScreen";
import { useEffect } from "react";

export default function Logout() {
  const { logout } = useAuthContext();

  useEffect(() => {
    logout();
  }, [logout]);

  return <LoadingScreen/>;
}
